import { render, staticRenderFns } from "./ContactManagement.vue?vue&type=template&id=9560fb10&"
import script from "./ContactManagement.vue?vue&type=script&lang=js&"
export * from "./ContactManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports